<template>
    <div>
        <b-list-group v-if="locations.length > 0">
            <b-list-group-item
                v-for="loc in locations"
                :key="`${prefix}-loc-${loc.id}`"
                class="d-flex align-items-center justify-content-between"
                :class="{ 'location-locked': isLocked(loc.id) }"
            >
                <div class="text-truncate pr-3">
                    <div>
                        {{ loc.title }}
                    </div>

                    <div class="text-muted">
                        {{ loc.uniq_id }}
                    </div>

                    <div v-if="isLocked(loc.id)" class="text-danger small mt-1">
                        {{__t('ALREADY_ATTACHED')}}
                        {{ getAttachedName(loc.id) }}
                        #{{ getAttachedSettingId(loc.id) }}
                    </div>
                </div>

                <div class="custom-control custom-switch">
                    <input
                        :id="`${prefix}-loc-${loc.id}`"
                        type="checkbox"
                        class="custom-control-input"
                        :checked="isAttached(loc.id)"
                        :disabled="isLocked(loc.id)"
                        @change="$emit('toggle', loc)"
                    >

                    <label
                        class="custom-control-label"
                        :for="`${prefix}-loc-${loc.id}`"
                    ></label>
                </div>
            </b-list-group-item>
        </b-list-group>

        <div v-else class="alert alert-info mb-0">
            Немає локацій
        </div>
    </div>
</template>

<script>
export default {
    name: "payment_location_list",

    props: {
        locations: {
            type: Array,
            default() {
                return [];
            }
        },

        attachedLocationIds: {
            type: Array,
            default() {
                return [];
            }
        },

        attachedLocations: {
            type: Array,
            default() {
                return [];
            }
        },

        currentPaymentId: {
            type: [Number, String],
            default: 0
        },

        prefix: {
            type: String,
            default: 'loc'
        }
    },

    methods: {
        isAttached(id) {
            return this.attachedLocationIds
                .map(item => String(item))
                .includes(String(id));
        },

        getAttachedItem(id) {
            return this.attachedLocations.find(item => {
                return String(item.loc_id) === String(id);
            }) || null;
        },

        isLocked(id) {
            const item = this.getAttachedItem(id);

            if (!item || !item.attached_id) {
                return false;
            }

            return String(item.attached_id.setting_id) !== String(this.currentPaymentId);
        },

        getAttachedName(id) {
            const item = this.getAttachedItem(id);

            return item?.attached_id?.name || '';
        },

        getAttachedSettingId(id) {
            const item = this.getAttachedItem(id);

            return item?.attached_id?.setting_id || '';
        }
    }
}
</script>

<style scoped>
.location-locked {
    background: #f8f9fa;
    opacity: 0.75;
}
</style>
